<template>
    <div class="card-body">
        <slot />
    </div>
</template>

<script setup>
</script>

<style scoped>
.card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.25rem;
}
</style>
